import { render } from "./FaqList.vue?vue&type=template&id=021ffd37&scoped=true"
import script from "./FaqList.vue?vue&type=script&lang=js"
export * from "./FaqList.vue?vue&type=script&lang=js"

import "./FaqList.vue?vue&type=style&index=0&id=021ffd37&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021ffd37"]])

export default __exports__